/// <amd-module name="TFS/Admin/Views/OrganizationOverview/Contracts/DataModels" />
import { WebSessionToken } from "VSS/Platform/Contracts/Authentication";

export interface IOrganizationOverviewData {
    id: string;
    name: string;
    url: string;
    privacyUrl: string;
    description: string;
    region: string;
    geography?: string | null | undefined;
    readOnly: boolean;
    timeZone: ITimeZone;
    hasModifyPermissions: boolean;
    avatarUrl: string;
}

export interface IOrganizationOverviewDelayLoadData {
    isOwner: boolean;
    allTimeZones: [ITimeZone];
    currentOwner: IOwner;
    currentUserId: string;
    hasDeletePermissions: boolean;
    hasModifyPermissions: boolean;
    showDomainMigration: boolean;
    disableDomainMigration: boolean;
    devOpsDomainUrls: boolean;
    targetDomainUrl: string;
    organizationTakeover?: {
        isEligibleForTakeOver: boolean;
        isAzureDevOpsAdministrator: boolean;
    };
}

export interface ITimeZone {
    displayName: string;
    id: string;
}

export interface IOwner {
    name: string;
    id: string;
    email: string;
}

export interface IOrganizationTokenData {
    deploymentLevelSessionToken?: WebSessionToken;
    enterpriseLevelSessionToken?: WebSessionToken;
}
